var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgRibbon = function SvgRibbon(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5C5 3.89543 5.89543 3 7 3L17 3C18.1046 3 19 3.89543 19 5L19 20C19 20.388 18.7755 20.741 18.4242 20.9056C18.0728 21.0702 17.6579 21.0166 17.3598 20.7682L12 16.3017L6.64018 20.7682C6.3421 21.0166 5.92723 21.0702 5.57584 20.9056C5.22446 20.741 5 20.388 5 20L5 5ZM17 5L7 5L7 17.865L11.3598 14.2318C11.7307 13.9227 12.2693 13.9227 12.6402 14.2318L17 17.865V5Z",
    fill: "black"
  })));
};
export { SvgRibbon as ReactComponent };
export default __webpack_public_path__ + "static/media/ribbon.5fb76f92.svg";